type Language = 'en' | 'de';

async function accountLanguage(token: string, language?: Language, signal?: AbortSignal): Promise<Language | null> {
  const base = process.env.REACT_APP_REST_API_URI_v2;
  if (!base) throw new Error('Language service is unavailable');
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  if (signal?.aborted) controller.abort();
  const timer = setTimeout(abort, 10000);
  try {
    const response = await fetch(`${base.replace(/\/$/, '')}/api/v1/account/language`, {
      method: language ? 'PUT' : 'GET',
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json',
        ...(language ? { 'Content-Type': 'application/json', 'Accept-Language': language } : {}) },
      ...(language ? { body: JSON.stringify({ language }) } : {}),
      cache: 'no-store', signal: controller.signal,
    });
    if (!response.ok) throw new Error('Language service is unavailable');
    const body = await response.json();
    if (body.language !== null && body.language !== 'en' && body.language !== 'de') throw new Error('Invalid language preference');
    if (language && body.language !== language) throw new Error('Language preference was not saved');
    return body.language;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
  }
}

export const getAccountLanguage = (token: string, signal: AbortSignal) => accountLanguage(token, undefined, signal);
export const saveAccountLanguage = (token: string, language: Language) => accountLanguage(token, language);
